//@flow
import React from "react"
import styled from "styled-components"
import { StyleableIcon, StyleableLink } from "../Sidebar"
import { LinkButton } from "../Buttons"

export const EntityList = styled.ol`
  margin: 0.5rem 0;
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0;
`

export const BaseEntity = styled.li`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 0.5rem;
`

export const Entity = BaseEntity.extend`
  &:nth-child(odd) {
    background: rgba(0, 0, 0, 0.05);
  }
`

export const EntityHeading = BaseEntity.extend`
  background: ${props => props.theme.backgroundGradientDark};
  color: #fff;
  font-weight: bold;
`

export const EntityDetail = styled.span`
  display: flex;
  flex-grow: ${props => props.grow || 0};
  flex-basis: 2rem;
  flex-direction: ${props => (props.row ? "row" : "col")};
  justify-content: ${props => (props.end ? "flex-end" : "flex-start")};
`

export const CenteredEntityDetail = EntityDetail.extend`align-items: center;`

export const EntityActionIcon = styled(StyleableIcon)`
  font-size: 1rem;
`

export const EntityPrimaryLink = styled(StyleableLink)`
  font-weight: bold;
  color: ${props => props.theme.accent};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

const ActionLink = LinkButton.extend`padding: 0.25rem;`

export const EntityAction = ({
  icon,
  onClick,
  ...props
}: {
  icon: string,
  onClick: Function
}) =>
  <ActionLink
    onClick={e => {
      e.preventDefault()
      onClick()
    }}
  >
    <EntityActionIcon>
      {icon}
    </EntityActionIcon>
  </ActionLink>



// WEBPACK FOOTER //
// ./src/UI/EntityList/index.js